/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { IoMdClose } from 'react-icons/io';
import { MdClose } from 'react-icons/md';
import AceEditor from 'react-ace';
import { toast } from 'react-toastify';

import { Container, Shaddow, ImageModal } from './styles';
import api from '~/services/api';

export default function WrongModal({ closeModal, id }) {
  const [scorecard, setScorecard] = useState('');
  const [challenge, setChallenge] = useState('');
  const [newAnswer, setNewAnser] = useState('');
  const [code, setCode] = useState('');
  const [showImage, setShowImage] = useState(false);

  useEffect(() => {
    async function getData() {
      const { data } = await api.get(`scorecards/${id}`);

      setScorecard(data);
      setChallenge(data.challenge);
      setNewAnser(data.link_answer);
      setCode(data.code_answer);
    }

    getData();
  }, [id]);

  function onLoad() {}

  function onChangeCode(newValue) {
    setCode(newValue);
  }

  const handleInputChange = (e) => {
    const { value } = e.target;
    setNewAnser(value);
  };

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      if (newAnswer.length >= 1) {
        await api.put(`challenges/${id}/scorecards`, {
          link_answer: newAnswer,
        });
        return toast.success('Resposta enviada com sucesso', {
          onClose: () => window.location.reload(),
          autoClose: 2000,
        });
      }
      return toast.error('Preencha o campo de resposta e tente novamente.');
    } catch (error) {
      return toast.error('Desafio já enviado, veja sua página de desafios.');
    }
  }

  async function handleSubmitCode(e) {
    e.preventDefault();

    try {
      if (code.length > 5) {
        await api.put(`challenges/${id}/scorecards`, {
          code_answer: code,
        });
        return toast.success('Resposta enviada com sucesso', {
          onClose: () => window.location.reload(),
          autoClose: 2000,
        });
      }
      return toast.error('Preencha o campo de resposta e tente novamente.');
    } catch (error) {
      return toast.error('Desafio já enviado, veja sua página de desafios.');
    }
  }

  function handleShowImage() {
    return showImage === false ? setShowImage(true) : setShowImage(false);
  }

  return (
    <Shaddow>
      <Container>
        {showImage ? (
          <ImageModal>
            <button type="button" onClick={handleShowImage}>
              <MdClose size={30} color="#090f35" />
            </button>
            <img src={challenge.file.url} alt="imagem-desafio" />
          </ImageModal>
        ) : null}
        <button type="button" className="icon">
          <IoMdClose size={30} color="#090f35" onClick={closeModal} />
        </button>
        <h2>Pergunta</h2>
        <p>{challenge.question}</p>
        <h2>Feedback</h2>
        <div className="feedback">
          <p>
            {scorecard.feedback !== null
              ? scorecard.feedback
              : 'Resposta errada, por favor, tente novamente.'}
          </p>
        </div>
        <div className="line" />
        {challenge.link_question === null ? null : (
          <a
            href={`${challenge.link_question}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Link de Referência
          </a>
        )}
        {challenge.file_id === null ? null : (
          <button
            className="link"
            type="button"
            onClick={handleShowImage}
            style={{ marginLeft: 20 }}
          >
            Imagem de Referência
          </button>
        )}
        <h2>SUA RESPOSTA:</h2>
        {challenge.type === 'code' ? (
          <AceEditor
            placeholder="Sua Resposta"
            mode={`${challenge.language}`}
            theme="dracula"
            name="blah2"
            onLoad={onLoad}
            onChange={onChangeCode}
            fontSize={14}
            showPrintMargin
            showGutter
            highlightActiveLine
            value={code === '' ? '.' : code}
            width="56vw"
            height="400px"
            setOptions={{
              enableBasicAutocompletion: true,
              enableLiveAutocompletion: true,
              enableSnippets: true,
              showLineNumbers: true,
              tabSize: 2,
            }}
          />
        ) : (
          <textarea
            type="text"
            value={newAnswer}
            onChange={handleInputChange}
          />
        )}
        <button
          className="submit"
          type="button"
          onClick={
            challenge.type === 'code'
              ? (e) => handleSubmitCode(e)
              : (e) => handleSubmit(e)
          }
          style={{ marginLeft: 20 }}
        >
          ENVIAR CORREÇĀO
        </button>
      </Container>
    </Shaddow>
  );
}
